import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import Loginheader from '../Loginheader';
import Menu from '../Menu';

import * as Common from '../Common';

function Extract() {
    const navigate = useNavigate();


    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [repFromDate, setRepFromDate] = useState(new Date());
    const [repToDate, setRepToDate] = useState(new Date());
    const [repMode, setRepMode] = useState("D");
    const [repType, setRepType] = useState("P");
    const [repOutput, setRepOutput] = useState("");

    const [reqBranch, setReqBranch] = useState("0");
    const [ddReqBranchOptions, setDdReqBranchOptions] = useState([]);

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);

    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPDATAEXTRACT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiUser, [sid, 'branchallowedall'], function (result) {
                        let resp1 = JSON.parse(result);
                        setDdReqBranchOptions(resp1);
                        if (resp1.length === 2) {
                            setReqBranch(resp1[1].value);
                        }
                    });
                    Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                        setDdReqAgentOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttall'], function (result) {
                        setDdReqPurposeOptions(JSON.parse(result));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function genReport() {
        var object1 = {
            right: 'REPDATAEXTRACT',
            mode: repMode,
            frmdt: Common.dateYMD(repFromDate),
            todt: Common.dateYMD(repToDate),
            type: repType,
            reqAgent: reqAgent,
            reqBranch: reqBranch,
            reqPurpose: reqPurpose
        }
        console.log(object1);
        if (repMode === "D") {
            Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(object1)]);
        } else if (repMode === "V") {
            Common.callApi(Common.apiReport, [sid, JSON.stringify(object1)], function (result) {
                setRepOutput(result);
            });
        }
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Data Extract</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className='divHide'>
                        <Form.Group>
                            <Form.Label>Mode </Form.Label>
                            <Form.Select
                                value={repMode}
                                onChange={(e) => setRepMode(e.target.value)} >
                                <option value="D">Download</option>
                                <option value="V">View</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col >
                        <Form.Group>
                            <Form.Label>Type </Form.Label>
                            <Form.Select
                                value={repType}
                                onChange={(e) => setRepType(e.target.value)} >
                                <option value="P">Processed</option>
                                <option value="R">Requested</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Branch<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqBranch}
                                onChange={(e) => setReqBranch(e.target.value)}
                                disabled={entityType === 'A' || ddReqBranchOptions.length === 2} >
                                {ddReqBranchOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Agent</Form.Label>
                            <Form.Select
                                value={reqAgent}
                                onChange={(e) => setReqAgent(e.target.value)}
                                disabled={entityType === 'A'} >
                                {ddReqAgentOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Purpose</Form.Label>
                            <Form.Select
                                value={reqPurpose}
                                onChange={(e) => setReqPurpose(e.target.value)}  >
                                <input type="text" />
                                {ddReqPurposeOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={repFromDate}
                                onChange={(date) => setRepFromDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={repToDate}
                                onChange={(date) => setRepToDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col>&nbsp;</Col><Col>&nbsp;</Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button variant="outline-primary" size="sm" onClick={() => genReport()}>Generate</Button>&nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {parse(repOutput)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
            </Container>

        </>
    );
}
export default Extract;